<template>
    <div class="gh-home-video">
        <div v-if="screenWidth > 480" class="gh-home-video-outer">
            <video class="gh-video" width="100%" autoplay muted loop>
                <source src="/images/Salon_X_Papas.mp4" type="video/mp4">
            </video>
        </div>
        <div v-else class="gh-home-mobile">
            <div></div>
            <img src="/images/SalonXPapas-Stacked-Logo-Wht.svg" class="gh-home-mobile-logo" alt="">
            <div class="gh-home-mobile-contact">
                <a class="gh-button" href="/bookings#booking-form">MAKE AN APPOINTMENT</a>
                <p>
                    <gh-button-call>07 3569 6800</gh-button-call>
                    <br>
                    <a href="/our-salon#map">18 LONGLAND ST, NEWSTEAD</a>
                </p>

            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ghHomeVideo',

    props: {
      logo: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        screenWidth: window.innerWidth,
      }
    },

    mounted() {
      window.addEventListener("resize", this.resize)
    },

    methods: {
      toggleMenu() {
        this.isOpened = !this.isOpened
      },

      resize() {
        this.screenWidth = window.innerWidth
      }
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.resize);
    }
  }
</script>

<style scoped lang="sass">
    .gh-home-video
        height: 100%
        .gh-video
            position: fixed
            top: 50%
            left: 50%
            min-width: 100%
            min-height: 100%
            width: auto
            height: auto
            transform: translateX(-50%) translateY(-50%)
            background: #000
            transition: 1s opacity
        .gh-home-mobile-video
            height: 100vh
            background: url('/images/Style1-Women-bw@2x.jpg') no-repeat center top/cover
</style>
